(() => {
  const init = () => {
    if (!document.querySelector('.sd-trio-hero')) return;
    const box = document.querySelector('.byob');
    if (!box || box.dataset.sdTrioReady) return;
    box.dataset.sdTrioReady = 'true';
    const bar = box.querySelector('.byob__bar');
    if (bar) bar.id = 'sd-trio-summary';
    box.querySelectorAll('.byob__title').forEach(title => {
      title.textContent = title.textContent.replace(/^MINI\s+/i, '').replace(/\s*CANDLE\s*—\s*90g\s*$/i, '').toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase());
    });
    const preferred = ['Sunday Morning', 'Poolside', 'Golden Amber', 'Roses At The Theatre', 'Ember & Velvet', 'Golden Pear'];
    const grid = box.querySelector('.byob__grid');
    if (grid) {
      const children = [...grid.children];
      children.sort((a,b) => {
        const rank = el => {const text = el.querySelector('.byob__title')?.textContent || '';const i=preferred.indexOf(text);return i < 0 ? 99 : i;};
        return rank(a)-rank(b);
      }).forEach(el => grid.append(el));
    }
  };
  init();
  const observer = new MutationObserver(() => {init();if(document.querySelector('.byob[data-sd-trio-ready]')) observer.disconnect();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);
})();
